import { useEffect, useState } from "react";
import api from "../../configs/api";
import ProjectCard from "../../components/common/ProjectCard";
import { ProjectSkeleton } from "../../components/common/ProjectCard";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjects = async () => {
    try {
      setLoading(true);

      const res = await api.get("/projects?page=1&limit=100");

      const { projects } = res.data.data;

      setProjects(projects);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <div className="w-full bg-white px-4 md:px-8 lg:px-10 py-16">
      {/* PAGE TITLE */}
      <div className="text-center mb-14">
        <span
          className="text-xs font-medium tracking-widest uppercase"
          style={{ color: "#c020d0", letterSpacing: "0.2em" }}
        >
          [OUR PROJECTS]
        </span>

        <h1 className="text-3xl md:text-4xl lg:text-5xl text-[#041122] font-heading font-semibold mt-4">
          Explore Our Projects
        </h1>
      </div>

      {/* GRID */}
      <div className="grid md:grid-cols-3 gap-y-8 gap-x-4">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => <ProjectSkeleton key={i} />)
          : projects.map((project, index) => (
              <ProjectCard
                key={project._id}
                project={project}
                index={index}
                visible={true}
              />
            ))}
      </div>
    </div>
  );
};

export default Projects;
